export const device_platform = {
  android: 'android',
  ios: 'ios',
  mac: 'mac',
};

export const APPS_LINK = {
  android:
    'https://play.google.com/store/apps/details?id=in.gov.umang.negd.g2c&referrer=utm_source=ref&utm_medium=invite',
  ios: 'https://apps.apple.com/app/apple-store/id1236448857',
};
